// extracted by mini-css-extract-plugin
module.exports = {"skip_link":"SkipLink_skip_link__1MYB8"};